export const PRIMARY_COLOR = 'blue';
